<template>
  <div>
    <review-container />
  </div>
</template>

<script>
import ReviewContainer from '../../containers/Review/ReviewContainer.vue'

export default {
  components: {
    ReviewContainer,
  },
}
</script>

<style></style>
